var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.36 15.53.037.624-.63-.077c-2.29-.292-4.293-1.283-5.993-2.949l-.83-.826-.215.61c-.453 1.36-.163 2.797.781 3.763.504.534.39.61-.478.292-.303-.101-.567-.178-.592-.14-.088.09.214 1.246.453 1.704.327.635.995 1.258 1.725 1.627l.617.292-.73.013c-.705 0-.73.012-.655.28.252.826 1.247 1.703 2.354 2.084l.781.267-.68.407a7.09 7.09 0 0 1-3.374.94c-.567.013-1.033.064-1.033.102 0 .127 1.537.839 2.43 1.119 2.682.826 5.868.47 8.26-.941 1.7-1.004 3.4-3 4.193-4.932.428-1.03.856-2.91.856-3.813 0-.585.037-.661.743-1.36.415-.407.805-.852.88-.98.127-.24.114-.24-.528-.024-1.07.38-1.221.33-.692-.242.39-.407.856-1.144.856-1.36 0-.038-.19.025-.403.14-.227.127-.73.317-1.108.432l-.68.216-.617-.42c-.34-.228-.818-.482-1.07-.559-.642-.178-1.624-.152-2.204.051-1.573.572-2.568 2.046-2.455 3.66z",
    fill: "#55ACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.5dc15a23723594332a1ad87bda8dd4ab.svg";
export { ForwardRef as ReactComponent };